const STATE_COORDINATES: Record<string, [number, number]> = {
  AL: [-86.902298, 32.31823],
  AK: [-152.26833, 63.588753],
  AZ: [-111.093731, 34.048928],
  AR: [-91.831833, 34.969704],
  CA: [-119.417931, 36.778261],
  CO: [-105.782067, 39.550051],
  CT: [-73.087749, 41.603221],
  DE: [-75.52767, 38.910832],
  FL: [-81.515754, 27.664827],
  GA: [-82.907123, 32.165622],
  HI: [-155.582782, 19.896766],
  ID: [-114.742041, 44.068202],
  IL: [-89.398528, 40.633125],
  IN: [-86.134902, 40.267194],
  IA: [-93.097702, 41.878003],
  KS: [-98.484246, 39.011902],
  KY: [-84.270018, 37.839333],
  LA: [-91.962333, 30.984298],
  ME: [-69.445469, 45.253783],
  MD: [-76.641271, 39.045755],
  MA: [-71.382437, 42.407211],
  MI: [-85.602364, 44.314844],
  MN: [-94.6859, 46.729553],
  MS: [-89.398528, 32.354668],
  MO: [-91.831833, 37.964253],
  MT: [-110.362566, 46.879682],
  NE: [-99.901813, 41.492537],
  NV: [-116.419389, 38.80261],
  NH: [-71.572395, 43.193852],
  NJ: [-74.405661, 40.058324],
  NM: [-105.032363, 34.97273],
  NY: [-74.005941, 43.299428],
  NC: [-79.0193, 35.759573],
  ND: [-101.002012, 47.551493],
  OH: [-82.907123, 40.417287],
  OK: [-97.092877, 35.007752],
  OR: [-120.554201, 43.804133],
  PA: [-77.194525, 41.203322],
  RI: [-71.477429, 41.580095],
  SC: [-81.163725, 33.836081],
  SD: [-99.901813, 43.969515],
  TN: [-86.580447, 35.517491],
  TX: [-99.901813, 31.968599],
  UT: [-111.093731, 39.32155],
  VT: [-72.577841, 44.558803],
  VA: [-78.656894, 37.431573],
  WA: [-120.740139, 47.751074],
  WV: [-80.454903, 38.597626],
  WI: [-88.787868, 43.78444],
  WY: [-107.290284, 43.075968],
  DC: [-77.036873, 38.907192],
  PR: [-66.590149, 18.220833],
};

const STATE_NAME_TO_CODE: Record<string, string> = {
  ALABAMA: "AL",
  ALASKA: "AK",
  ARIZONA: "AZ",
  ARKANSAS: "AR",
  CALIFORNIA: "CA",
  COLORADO: "CO",
  CONNECTICUT: "CT",
  DELAWARE: "DE",
  FLORIDA: "FL",
  GEORGIA: "GA",
  HAWAII: "HI",
  IDAHO: "ID",
  ILLINOIS: "IL",
  INDIANA: "IN",
  IOWA: "IA",
  KANSAS: "KS",
  KENTUCKY: "KY",
  LOUISIANA: "LA",
  MAINE: "ME",
  MARYLAND: "MD",
  MASSACHUSETTS: "MA",
  MICHIGAN: "MI",
  MINNESOTA: "MN",
  MISSISSIPPI: "MS",
  MISSOURI: "MO",
  MONTANA: "MT",
  NEBRASKA: "NE",
  NEVADA: "NV",
  "NEW HAMPSHIRE": "NH",
  "NEW JERSEY": "NJ",
  "NEW MEXICO": "NM",
  "NEW YORK": "NY",
  "NORTH CAROLINA": "NC",
  "NORTH DAKOTA": "ND",
  OHIO: "OH",
  OKLAHOMA: "OK",
  OREGON: "OR",
  PENNSYLVANIA: "PA",
  "RHODE ISLAND": "RI",
  "SOUTH CAROLINA": "SC",
  "SOUTH DAKOTA": "SD",
  TENNESSEE: "TN",
  TEXAS: "TX",
  UTAH: "UT",
  VERMONT: "VT",
  VIRGINIA: "VA",
  WASHINGTON: "WA",
  "WEST VIRGINIA": "WV",
  WISCONSIN: "WI",
  WYOMING: "WY",
  "DISTRICT OF COLUMBIA": "DC",
  "WASHINGTON DC": "DC",
  "WASHINGTON D.C.": "DC",
  "PUERTO RICO": "PR",
};

const sanitizeRegion = (value: string) => value.replace(/[.\s]/g, "").toUpperCase();

export function getStateCentroid(input?: string | null): [number, number] | null {
  if (!input) return null;
  const trimmed = input.trim();
  if (!trimmed) return null;
  const upper = trimmed.toUpperCase();
  if (STATE_COORDINATES[upper]) {
    return STATE_COORDINATES[upper];
  }

  const alias = STATE_NAME_TO_CODE[upper];
  if (alias && STATE_COORDINATES[alias]) {
    return STATE_COORDINATES[alias];
  }

  const sanitized = sanitizeRegion(trimmed);
  if (STATE_COORDINATES[sanitized]) {
    return STATE_COORDINATES[sanitized];
  }
  const sanitizedAlias = STATE_NAME_TO_CODE[sanitized];
  if (sanitizedAlias && STATE_COORDINATES[sanitizedAlias]) {
    return STATE_COORDINATES[sanitizedAlias];
  }

  return null;
}
